module.exports = __webpack_public_path__ + "68d569ee70739abe0f7ea9cc80b53d2d.svg";